import {
	DefineGatewayRequest,
	Gateway,
	ManageGatewayConditionsRequest,
	ProcessBuilderPage,
	Variable,
} from '@/scripts/types/generated';
import {Page} from '@inertiajs/core';
import {sendUpdateRequest} from '@/scripts/utils/crud-requests.ts';

const gateways = ref<Gateway[]>();
const isLoading = ref<boolean>(false);

export const useGateways = () => {
	const refreshGateways = (page: Page<ProcessBuilderPage>) => {
		gateways.value = page.props.gateways;
	};

	const initGateways = async () => {
		while (isLoading.value) {
			await new Promise((resolve) => setTimeout(resolve, 100));
		}

		if (gateways.value) return;

		isLoading.value = true;
		const page = await sendReloadRequest<ProcessBuilderPage>(['gateways']);
		refreshGateways(page);
		isLoading.value = false;
	};

	const createGateway = async (
		request: DefineGatewayRequest
	): Promise<Gateway> => {
		const page = await sendCreateRequest<ProcessBuilderPage>(
			route('tenant.gateways.store'),
			request,
			['gateways']
		);

		return new Promise<Gateway>((resolve) => {
			refreshGateways(page);
			const newGateway = gateways.value.find(
				(gateway) => gateway.name === request.name
			);
			resolve(newGateway);
		});
	};

	const updateGatewayConditions = async (
		versionUuid: string,
		request: ManageGatewayConditionsRequest
	) => {
		const page = await sendUpdateRequest<ProcessBuilderPage>(
			route('tenant.gateways.conditions.update', {
				gatewayVersion: versionUuid,
			}),
			request,
			['gateways']
		);

		return new Promise<Gateway>((resolve) => {
			refreshGateways(page);
			const newGateway = gateways.value.find(
				(gateway) => gateway.versionUuid === versionUuid
			);
			resolve(newGateway);
		});
	};

	const deleteGateway = async (slug: string): Promise<void> => {
		const page = await sendDeleteRequest<ProcessBuilderPage>(
			route('tenant.gateways.destroy', {
				gateway: slug,
			}),
			['gateways']
		);

		return new Promise<void>((resolve) => {
			refreshGateways(page);
			resolve();
		});
	};

	const getGateway = async (versionUuid: string): Promise<Gateway> => {
		if (!gateways.value) {
			await initGateways();
		}

		return gateways.value.find(
			(gateway) => gateway.versionUuid === versionUuid
		);
	};

	const getGatewayVariables = (gateway: Gateway): Variable[] => {
		const variables: Variable[] = [];

		console.log('get gateway variables', gateway.name);

		return variables;
	};

	const setGateways = (newGateways: Gateway[]) => {
		gateways.value = newGateways;
	};

	return {
		gateways,
		initGateways,
		createGateway,
		updateGatewayConditions,
		deleteGateway,
		getGateway,
		getGatewayVariables,
		setGateways,
	};
};
